import { Action } from 'typescript-fsa';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { formValueSelector } from 'redux-form';
import { formatISO } from 'date-fns';

import { hideLoader, showLoader } from '@topconagriculture/loader';

import { LoadersNames } from '../../ui/ui.constants';
import { DownloadEntityType } from '../../entities/reports/reports.constants';
import {
  getCheckedFeedingPeriods,
  getDataTransferMethod,
  getEffectiveDate,
  getSelectedMixersScaleNumber,
} from '../loadMixers/loadMixers.selector';
import api from '../../../core/api';
import { notificationError } from '../../../core/helpers/utils/notificationUtils';
import { composeErrorMessage } from '../../../core/helpers/utils/utils';
import { previewLoadReport } from './pdf.actions';
import { DataTransferMethods } from '../loadMixers/loadMixers.types';

export function* previewDownloadListSaga(action: Action<{ entity: 'feedingList' | 'feedingsLoads' }>) {
  yield put(showLoader(LoadersNames.previewPDF));

  const params: any = {
    hideNotInUse: true,
  };

  const formNameByEntity = {
    feedingsLoads: DownloadEntityType.FeedingsLoads,
    feedingsList: DownloadEntityType.FeedingsList,
  };

  const entity = action.payload.entity;

  const valuesSelector = formValueSelector(formNameByEntity[entity]);
  params.hideNotInUse = yield select(valuesSelector, 'hideNotInUse');
  params.mixers = yield select(getSelectedMixersScaleNumber);
  params.periods = yield select(getCheckedFeedingPeriods);
  params.hideClosed = yield select(valuesSelector, 'hideClosed');
  const effectiveDate = yield select(getEffectiveDate);
  const dataTransferMethod = yield select(getDataTransferMethod);
  params.channel = dataTransferMethod;

  if (dataTransferMethod === DataTransferMethods.FEEDING_SYSTEM) {
    params.effectiveDate = formatISO(effectiveDate, { representation: 'date' });
  }

  try {
    const result = yield call(api.reports.previewLoadsReport, entity, params);
    yield put(previewLoadReport.done(result));
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
  yield put(hideLoader(LoadersNames.previewPDF));
}

export function* watchPDFSaga() {
  yield takeLatest(previewLoadReport.started, previewDownloadListSaga);
}
